import React from 'react';
import { Expense } from '../types/booking.types';

interface ExpensesTabProps {
  expenses: Expense[];
  onAddExpense: () => void;
}

const ExpensesTab: React.FC<ExpensesTabProps> = ({ expenses, onAddExpense }) => {
  const getText = (value: unknown) =>
    value === null || value === undefined || value === '' ? 'N/A' : String(value);

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800 flex items-center">
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Expenses & Costs
        </h3>
        <button
          className="bg-red-600 text-white px-4 py-2 rounded-lg shadow hover:bg-red-700 transition-all text-sm font-medium"
          onClick={onAddExpense}
        >
          + Add Expense
        </button>
      </div>
      <div className="overflow-x-auto bg-white border border-gray-200 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">#</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Amount</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Method</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Transaction ID</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Description</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Vendor</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Date</th>
            </tr>
          </thead>
          <tbody>
            {expenses.length > 0 ? (
              expenses.map((expense, index) => (
                <tr className="border-b border-gray-100 hover:bg-gray-50" key={expense.id}>
                  <td className="py-3 px-4 font-semibold text-gray-700">{index + 1}</td>
                  <td className="py-3 px-4 font-bold text-gray-800">
                    Rs {parseFloat(String((expense as any).amount ?? (expense as any).expense_amount ?? 0)).toFixed(2)}
                  </td>
                  <td className="py-3 px-4 text-gray-700">
                    {getText((expense as any).payment_method ?? (expense as any).payment_mode ?? (expense as any).method)}
                  </td>
                  <td className="py-3 px-4 text-gray-700">
                    {getText((expense as any).transaction_id ?? (expense as any).transactionId ?? (expense as any).reference_number)}
                  </td>
                  <td className="py-3 px-4 text-gray-700">{getText((expense as any).description ?? (expense as any).notes)}</td>
                  <td className="py-3 px-4 text-gray-700">
                    {getText((expense as any).vendor_or_client ?? (expense as any).vendor ?? (expense as any).paid_to)}
                  </td>
                  <td className="py-3 px-4 text-gray-600">
                    {(expense as any).created_at || (expense as any).paid_at
                      ? new Date((expense as any).created_at ?? (expense as any).paid_at).toLocaleDateString()
                      : 'N/A'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="py-8 text-center text-gray-500">
                  No expenses found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExpensesTab;
